module.exports = __webpack_public_path__ + "static/media/AxAgendamento.1fa3ff83.svg";